export const TECHNICAL_SERVICE_ACTION_TYPES = {
    SET_SAT_INVITATIONS: "TECHNICAL_SERVICE_SET_SAT_INVITATIONS",
};
